/* eslint jsx-a11y/label-has-associated-control: 0 */
/* eslint jsx-a11y/control-has-associated-label: 0 */
import React, { useEffect, useState } from 'react'

import { getFileByFilename, getFileURL } from '../../../../helpers/helper-file'
import IField from '../../../../interfaces/field'
import Icon from '../../../icon'
import TplGroup from '../tpl-group'

import {
  Thumb,
  ThumbImageWrapper,
  ThumbImage,
  Upload,
  NameWrapper,
  Info,
} from './styles'
import { If } from '../../../if/if'

type IProps = any & IField

const InputUpload = ({
  title,
  required = false,
  name,
  prefixName = '',
  hasPreview = true,
  ...el
}: IProps) => {
  const [fileInputed, setFileInputed] = useState<File | null>(null)
  const [fileByApi, setFileByApi] = useState<any | null>(null)
  const [imgURL, setImgURL] = useState<string>('')
  const [imgDimensions, setImgDimensions] = useState<string>('')

  useEffect(() => {
    if (el.values[`${prefixName}${name}`]?.uuid) {
      const currentFile = el.values[`${prefixName}${name}`]

      setFileByApi(currentFile)
      const url = getFileByFilename(currentFile.filename)
      setImgURL(url)
    } else {
      setFileByApi(null)
    }
  }, [el, prefixName, name])

  const onChange = (evt: any): void => {
    const file: File = evt.target.files[0]
    const url = getFileURL(file)
    setFileInputed(file)
    setImgURL(url)

    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, file)
    }
  }

  const onLoadImg = (evt: any) => {
    const { naturalWidth, naturalHeight } = evt.target
    const dimension = `${naturalWidth}px x ${naturalHeight}px`
    setImgDimensions(dimension)
  }

  const handleRemoveFile = (): void => {
    setFileInputed(null)
    setFileByApi(null)
    el.setFieldValue(`${prefixName}${name}`, '')
  }

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      {...el}
    >
      <If condition={hasPreview}>
        <Thumb>
          <ThumbImageWrapper>
            {
              fileInputed || fileByApi
                ? (<ThumbImage src={imgURL} onLoad={onLoadImg} />)
                : <Icon name="upload" />
            }
          </ThumbImageWrapper>
        </Thumb>
      </If>
      <Upload>
        <div>
          <label htmlFor={name}>Escolher arquivo...</label>
          <input
            required={required}
            onChange={onChange}
            type="file"
            name={`${prefixName}${name}`}
            id={name}
          />

          {
            fileInputed && !fileByApi && (
              <NameWrapper>
                <p>{fileInputed?.name}</p>
                <button type="button" onClick={handleRemoveFile}>
                  <Icon name="close" />
                </button>
              </NameWrapper>
            )
          }

          {
            fileByApi && (
              <NameWrapper>
                <p>{fileByApi?.filename}</p>
                <button type="button" onClick={handleRemoveFile}>
                  <Icon name="close" />
                </button>
              </NameWrapper>
            )
          }
        </div>

        <Info>
          <span>{fileInputed ? `Tamanho da imagem ${imgDimensions}` : ''}</span>
          <span>{el.description}</span>
        </Info>
      </Upload>
    </TplGroup>
  )
}

export default InputUpload
